<template>
  <div
    class="tw-bg-white tw-text-dorian-gray-800 tw-w-full tw-flex tw-items-center tw-p-4 tw-gap-4 tw-flex-col"
    :class="className"
  >
    <slot name="image">
      <div>
        <svg
          width="216"
          height="162"
          viewBox="0 0 216 162"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_1349_251"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="216"
            height="162"
          >
            <path d="M216 0H0V162H216V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_1349_251)">
            <path
              d="M178.001 50.9526C205.431 63.4848 194.055 112.102 153.461 139.209C112.867 166.315 18.2448 141.792 12.957 109.891C14.8143 83.7696 75.2266 101.415 108.958 78.8918C149.552 51.7853 150.57 38.4203 178.001 50.9526Z"
              fill="#E7E8E9"
            />
            <path
              d="M78.8274 33.8545H137.958V23.3977H79.7162C79.1504 23.3977 78.611 23.158 78.2318 22.7381L70.8397 14.5512C70.4605 14.1313 69.9211 13.8916 69.3553 13.8916H36.957C35.8525 13.8916 34.957 14.787 34.957 15.8916V33.8545H52.6006H70.2441H78.8274Z"
              fill="#BBE2DA"
            />
            <path
              d="M34.957 88.8916C34.957 89.9961 35.8525 90.8916 36.957 90.8916H135.958C137.062 90.8916 137.958 89.9961 137.958 88.8916V62.373V51.9162V33.8545H78.8274H70.2441H52.6006H34.957V88.8916Z"
              fill="#BBE2DA"
            />
            <path
              d="M34.957 33.8545V88.8916C34.957 89.9961 35.8525 90.8916 36.957 90.8916H135.958C137.062 90.8916 137.958 89.9961 137.958 88.8916V62.373M34.957 33.8545V15.8916C34.957 14.787 35.8525 13.8916 36.957 13.8916H69.3553C69.9211 13.8916 70.4605 14.1313 70.8397 14.5512L78.2318 22.7381C78.611 23.158 79.1504 23.3977 79.7162 23.3977H137.958M34.957 33.8545H52.6006H70.2441H78.8274H137.958M137.958 62.373V33.8545M137.958 62.373V51.9162M137.958 23.3977V33.8545M137.958 23.3977V51.9162M137.958 33.8545V51.9162M40.6793 44.3113H58.3228H67.1445H75.9663H82.1654H88.3645M40.6793 50.9656H58.3228H67.1445H75.9663"
              stroke="#97D3C6"
              stroke-width="3"
            />
            <path
              d="M149.745 95.6324C157.454 86.8909 156.589 73.5804 147.811 65.9024C139.034 58.2244 125.669 59.0865 117.959 67.828C110.25 76.5694 111.115 89.88 119.893 97.558C128.67 105.236 142.035 104.374 149.745 95.6324Z"
              fill="#DBF0EB"
              stroke="#3F9784"
              stroke-width="3"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M148.661 95.7164C148.296 96.1306 148.337 96.7612 148.753 97.1248L152.643 100.528L150.99 102.402C150.624 102.817 150.665 103.447 151.081 103.811L180.268 129.342C180.683 129.706 181.317 129.665 181.682 129.25L187.339 122.836C187.704 122.422 187.663 121.792 187.247 121.428L158.06 95.8968C157.645 95.5332 157.012 95.5742 156.646 95.9884L154.969 97.8898L151.079 94.4868C150.663 94.1232 150.03 94.1642 149.665 94.5784L148.661 95.7164Z"
              fill="#3F9784"
            />
            <mask
              id="mask1_1349_251"
              style="mask-type: luminance"
              maskUnits="userSpaceOnUse"
              x="148"
              y="94"
              width="40"
              height="36"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M148.661 95.7164C148.296 96.1306 148.337 96.7612 148.753 97.1248L152.643 100.528L150.99 102.402C150.624 102.817 150.665 103.447 151.081 103.811L180.268 129.342C180.683 129.706 181.317 129.665 181.682 129.25L187.339 122.836C187.704 122.422 187.663 121.792 187.247 121.428L158.06 95.8968C157.645 95.5332 157.012 95.5742 156.646 95.9884L154.969 97.8898L151.079 94.4868C150.663 94.1232 150.03 94.1642 149.665 94.5784L148.661 95.7164Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask1_1349_251)">
              <path
                d="M152.643 100.528L153.396 101.186L154.057 100.436L153.304 99.7777L152.643 100.528ZM154.969 97.8897L154.308 98.6397L155.061 99.2981L155.722 98.5481L154.969 97.8897ZM149.414 96.3747L147.909 95.0579C147.178 95.8863 147.26 97.1474 148.091 97.8747L149.414 96.3747ZM153.304 99.7777L149.414 96.3747L148.091 97.8747L151.981 101.278L153.304 99.7777ZM151.742 103.061L153.396 101.186L151.89 99.8693L150.237 101.744L151.742 103.061ZM151.742 103.061L150.237 101.744C149.506 102.572 149.588 103.833 150.419 104.561L151.742 103.061ZM180.929 128.592L151.742 103.061L150.419 104.561L179.606 130.092L180.929 128.592ZM180.929 128.592L179.606 130.092C180.438 130.819 181.704 130.737 182.435 129.909L180.929 128.592ZM186.586 122.178L180.929 128.592L182.435 129.909L188.091 123.495L186.586 122.178ZM186.586 122.178L188.091 123.495C188.822 122.666 188.74 121.405 187.909 120.678L186.586 122.178ZM157.399 96.6467L186.586 122.178L187.909 120.678L158.722 95.1467L157.399 96.6467ZM157.399 96.6467L158.722 95.1467C157.891 94.4195 156.624 94.5015 155.894 95.3299L157.399 96.6467ZM155.722 98.5481L157.399 96.6467L155.894 95.3299L154.217 97.2313L155.722 98.5481ZM150.418 95.2367L154.308 98.6397L155.631 97.1397L151.741 93.7367L150.418 95.2367ZM150.418 95.2367L151.741 93.7367C150.909 93.0095 149.643 93.0915 148.912 93.9199L150.418 95.2367ZM149.414 96.3747L150.418 95.2367L148.912 93.9199L147.909 95.0579L149.414 96.3747Z"
                fill="#3F9784"
              />
            </g>
          </g>
        </svg>
      </div>
    </slot>
    <div class="tw-flex tw-flex-col tw-gap-2 tw-text-center">
      <div class="tw-font-medium tw-text-xl">
        <slot name="title" />
      </div>
      <div class="tw-text-sm">
        <slot name="description" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps<{
  className?: Record<string, boolean> | string[] | string;
}>();

const { className } = toRefs(props);
</script>
